export default __webpack_public_path__ + "static/media/grupo-de-edad.8e9f67bd.png";